import { Coordinates } from '@shared/domain/subtopic/subtopic.aggregate';
import { useEffect, useRef, useState } from 'react';

interface Props {
  position: Coordinates;
  onClick: (newPosition: Coordinates) => void;
  background?: string;
}

export const ClickableCanvas = ({
  position: initialPosition,
  onClick,
  background
}: Props) => {
  const canvasRef = useRef<HTMLCanvasElement>(null);
  const [position, setPosition] = useState(initialPosition);
  const [imageBackground, setImageBackground] = useState<HTMLImageElement>();

  useEffect(() => {
    if (!background) {
      setImageBackground(undefined);
      return;
    }
    const img = new Image();
    img.src = background;
    img.onload = () => {
      setImageBackground(img);
    };
  }, [background]);

  useEffect(() => {
    const canvas = canvasRef.current;

    if (canvas && imageBackground) {
      canvas.width = canvas.offsetWidth;
      canvas.height = canvas.offsetHeight;
      const ctx = canvas.getContext('2d');
      ctx!.drawImage(imageBackground, 0, 0, canvas.width, canvas.height);
      ctx!.fillStyle = '#FF0000';
      ctx!.beginPath();
      ctx!.arc(position.x, position.y, 30, 0, 2 * Math.PI);
      ctx!.stroke();
      ctx!.fill();
    }
  }, [position.x, position.y, imageBackground]);

  return (
    <canvas
      ref={canvasRef}
      onClick={(event: React.MouseEvent<HTMLCanvasElement, MouseEvent>) => {
        let rect = (event.target as HTMLElement).getBoundingClientRect();
        let x = Math.round(event.clientX - rect.left);
        let y = Math.round(event.clientY - rect.top);
        setPosition({ x, y });
        onClick({ x, y });
      }}
      style={{ width: '100%', height: '100%' }}
    ></canvas>
  );
};
